import { Star } from "lucide-react";
import { HERO_GRID } from "../mock";

function Tile({ t, className = "", eager, parallax }) {
  return (
    <div
      data-anim={parallax ? "parallax" : undefined}
      className={`relative ${t.color} ${className} rounded-[22px] md:rounded-[26px] p-1.5 md:p-2 overflow-hidden group hover:-translate-y-1 transition-transform duration-500`}
    >
      <img
        src={t.image}
        alt={t.label}
        loading={eager ? "eager" : "lazy"}
        className="w-full h-full object-cover rounded-[16px] md:rounded-[20px] group-hover:scale-105 transition-transform duration-700"
      />
      <span className="absolute bottom-3 left-3 text-[10px] md:text-[11px] font-semibold bg-white/95 px-2 py-0.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
        {t.label}
      </span>
    </div>
  );
}

export default function HeroGrid() {
  return (
    <div
      className="grid grid-cols-3 md:grid-cols-[0.85fr_1fr_1.35fr_1fr_0.85fr] gap-3 md:gap-4 items-center"
      data-testid="hero-grid"
    >
      <div className="hidden md:block">
        <Tile t={HERO_GRID.far_left} className="aspect-[4/5] w-full" parallax />
      </div>
      <div className="flex flex-col gap-3 md:gap-4 -mt-10 md:-mt-16">
        <Tile t={HERO_GRID.left[0]} className="aspect-[4/3.6]" />
        <Tile t={HERO_GRID.left[1]} className="aspect-[4/4.6]" />
      </div>
      <div className="relative">
        <Star
          className="absolute -top-5 md:-top-7 left-1/2 -translate-x-1/2 text-black fill-black z-10 bounce-soft"
          size={30}
        />
        <Tile t={HERO_GRID.center} className="aspect-[3/5]" eager />
      </div>
      <div className="flex flex-col gap-3 md:gap-4 mt-10 md:mt-12">
        <Tile t={HERO_GRID.right[0]} className="aspect-[4/3.6]" />
        <Tile t={HERO_GRID.right[1]} className="aspect-[4/3.6]" parallax />
      </div>
      <div className="hidden md:block relative -mt-10">
        <Tile t={HERO_GRID.far_right} className="aspect-[4/4.4] w-full" />
        <p className="display text-lg mt-4 text-right pr-1" data-testid="hero-year-tag">
          #2025
        </p>
      </div>
    </div>
  );
}
